<template>
    <div class="printLabel">
        <edit-btns class="btn-box" 
            :bnts="bnts"
            @addClick="addFood()"
            @printClick="printClick()"  
            @deleteClick="deleteClick()"
            @goBackClick="goBack()"
            @outputClick="exportExcel()"/>
        <div class="data-box">
            <div class="flex-box">
                <div class="filter-box">
                    <div class="from-box">
                        <div class="lable-txt">标签模板:</div>
                        <div class="from-input">
                            <el-select v-model="Print_ModelID" placeholder="请选择打印模板">
                                <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in lable_printModels" :key="item"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="from-box">
                        <div class="lable-txt">促销类型:</div>
                        <div class="from-input" style="width: 140px;">
                            <el-select v-model="type">
                                <el-option label="不参与折扣" :value="1"></el-option>
                                <el-option label="按折扣率%" :value="2"></el-option>
                                <el-option label="指定促销价" :value="3"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="from-box">
                        <div class="lable-txt">生产日期:</div>
                        <div class="from-input" style="width: 165px;">
                            <el-date-picker class="from-date"
                                :clearable="false"
                                :editable="false"
                                v-model="produceDate"
                                type="date"
                                placeholder=""
                                :default-value="new Date()">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="from-box">
                        <div class="lable-txt">标签打印机:</div>
                        <div class="from-input">
                           <el-select v-model="Printer_ID" placeholder="请选择打印机">
                                <el-option :value="item.Printer_AutoID" :label="item.Printer_Desc+'('+item.Printer_Name+')'" v-for="item in printers" :key="item"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="table-box">
                    <el-table class="el-table--scrollable-y" ref="foodTable" style="width: 100%;height:100%"  
                        border
                        highlight-current-row
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                        :data="foodList"
                    >
                        <el-table-column fixed label="操作" width="60" type="edit">
                            <template #default="scope">
                                <i class="iconfont icon-shanchu" @click="delFood(scope.row,scope.$index)"></i>
                            </template>
                        </el-table-column>
                        <el-table-column fixed prop="Eat_XFCode" label="菜品编码" min-width="80" align="left"></el-table-column>
                        <el-table-column fixed prop="Eat_XFName" label="菜品名称" min-width="100" align="left"></el-table-column>
                        <el-table-column prop="Eat_XFSize" label="单位" min-width="80" ></el-table-column>
                        <el-table-column prop="Eat_SalePrice" label="售价" min-width="80" ></el-table-column>
                        <el-table-column prop="Print_Num" label="打印份数" min-width="120" is-render>
                            <template #header>
                                打印份数<span class="batch" @click="clickBatch('打印份数','Print_Num')">[批量]</span>
                            </template>
                            <template #default="scope">
                                <input-pattern class="printNum" :data-id="scope.$index" v-model="scope.row.Print_Num" pattern="number" :dplaces="0"/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Print_Per" label="折扣率%" min-width="120" is-render>
                            <template #header>
                                折扣率%<span class="batch" v-show="type==2" @click="clickBatch('折扣率%','Print_Per')">[批量]</span>
                                <el-tooltip  effect="dark" content="80代表八折" placement="top">
                                    <div class="tip">
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <template #default="scope">
                                <input-pattern v-if="type==2" v-model="scope.row.Print_Per" pattern="number" :dplaces="0" :min="0" :max="100" @change="perChange(scope.row)"/>
                                <template v-else>{{scope.row.Print_Per}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Food_CheckPrice" label="折后单价" min-width="120" is-render>
                            <template #header>
                                折后单价<span class="batch" v-show="type==3" @click="clickBatch('折后单价','Food_CheckPrice')">[批量]</span>
                            </template>
                            <template #default="scope">
                                <input-pattern v-if="type==3" v-model="scope.row.Food_CheckPrice" pattern="number" :dplaces="2"/>
                                <template v-else>{{scope.row.Food_CheckPrice}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="DiscountDesc" label="折扣描述" min-width="120" is-render>
                            <template #header>
                                折扣描述<span class="batch" v-show="type==2 || type==3" @click="clickBatch('折扣描述','DiscountDesc')">[批量]</span>
                            </template>
                            <template #default="scope">
                                <input v-if="scope.row.Eat_SalePrice!=scope.row.Food_CheckPrice" class="text" v-model="scope.row.DiscountDesc" type="text"/>
                                <template v-else>{{scope.row.DiscountDesc}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Batching" label="配料" min-width="100" ></el-table-column>
                        <el-table-column prop="Manufacturer" label="生产厂家" min-width="100" ></el-table-column>
                        <el-table-column prop="Retention_Time" label="保质期" min-width="80" ></el-table-column>
                        <el-table-column prop="Storage_conditions" label="存储条件" min-width="100" ></el-table-column>
                        <el-table-column prop="Eat_XFThirdCode" label="第三方编码" min-width="100" ></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- 选择菜品 -->
        <select-tree  ref="treeFood" isModel isSearch 
            :data="treeFoods" title="菜品选择"
            :filterNodeMethod="foodFilter"
            @change="changeFood"/>
        <number-modal :isShow="batNumShow" :dplaces="batNumKey=='Food_CheckPrice'?2:0" type="number" 
            :title="batNumTitle" 
            @close="batNumShow=false" @confirm="batConfirm" />
    </div>
</template>

<script>
export default {
    name:"printLabel",
    computed:{
        /**编辑按钮 */
        bnts(){
            let data=[{key:"add",text:"添加菜品"},"print",{key:"delete",text:"全部删除"},"output","goBack"];
            return data;
        },
        //半成品标签模板
        lable_printModels(){
            return this.printModels?.filter(t=>t.PrintModel_Type==907);
        },
        //菜品数据
        treeFoods(){
            let treeData=[];
            this.posFoodData?.forEach(item=>{
                let depart={
                    id:item.MainCategory_ID,
                    name:item.MainCategory_Name,
                    children:[],
                    Hierarchy:1
                }
                if(item.FoodSubCategorys){
                    item.FoodSubCategorys.forEach(eat=>{
                        if(eat.PosFoods?.length>0){
                            let chieat={
                                id:eat.SubCategory_ID,
                                name:eat.SubCategory_Name,
                                Hierarchy:2,
                                children:[]
                            }
                            eat.PosFoods.forEach(it=>{
                                chieat.children.push({
                                    id: it.Food_ID,
                                    name: it.Food_Name,
                                    Food_Code:it.Food_Code,
                                    Food_Name:it.Food_Name,
                                    Food_Size:it.Food_Size,
                                    Food_PinYin:it.Food_PinYin,
                                    SubCategory_ID:it.SubCategory_ID,
                                    SubCategory_Name:it.SubCategory_Name
                                })
                                it.MultipleSizeFoods?.forEach(item=>{
                                    chieat.children.push({
                                        id: item.Food_ID,
                                        name: item.Food_Name,
                                        Food_Code:item.Food_Code,
                                        Food_Name:item.Food_Name,
                                        Food_Size:item.Food_Size,
                                        Food_PinYin:item.Food_PinYin,
                                        SubCategory_ID:item.SubCategory_ID,
                                        SubCategory_Name:item.SubCategory_Name
                                    })
                                })
                            })
                            depart.children.push(chieat)
                        }
                    })
                }
                if(depart.children.length>0){
                    treeData.push(depart)
                }
               
            })
            
            return treeData;
        },
    },
    watch:{
        Printer_ID(newVal){//缓存
            this.$cacheData.set("printLable_printer_ID",newVal);
        },
        type(){
            this.foodList.forEach(it=>{
                
                it.Food_CheckPrice=it.Eat_SalePrice;
                it.Print_Per="";
                it.DiscountDesc='';
                if(this.type==3){
                    it.DiscountDesc='促销价';
                }
            })
        }
    },
    data(){
        return {
            //菜品数据
            posFoodData:[],
            printers:[],
            printModels:[],
            type:1,
            //生产日期
            produceDate:new Date(),
            //打印模板
            Print_ModelID:null,
            //打印机
            Printer_ID:null,
            foodList:[],
            batPringNum:1,
            /**数字批量 */
            batNumShow:false,
            /**标题 */
            batNumTitle:"",
            /**批量操作字段 */
            batNumKey:'',
            numInput:[]
        }
    },
    mounted(){
        let oldPrinter_ID=this.$cacheData.get("printLable_printer_ID");
        this.$cacheData.Printers().then((d)=>{
            this.printers=d;
            if(oldPrinter_ID && this.printers.some(it=>it.Printer_AutoID==oldPrinter_ID)){
                this.Printer_ID=oldPrinter_ID;
            }
        }).catch(e=>{
            console.log('打印机数据获取失败e:'+e)
        })
        this.$cacheData.PrintModels().then(d=>{
            this.printModels=d?.map(it=>{
                let json=Object.assign({},it);
                if(json.IsGroup){
                    json.PrintModel_Name='【区域】-'+json.PrintModel_Name;
                }else if(json.IsPublic){
                    json.PrintModel_Name='【公有】-'+json.PrintModel_Name;
                }else{
                    json.PrintModel_Name='【私有】-'+json.PrintModel_Name;
                }
                return json;
            })

        }).catch(e=>{
            console.log('打印模板数据获取失败e:'+e)
        });
        
    },
    methods:{
        //返回 
        goBack(){
            this.$router.back();
        },
        /**加载菜品 */
        loadFoods(){
            const loading = this.$loading({
                text: "获取菜品数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            //菜品数据结构
            this.$cacheData.AllPosFoods().then((d)=>{
                loading.close();
                this.posFoodData=d;
                console.log(d)
                this.$refs.treeFood?.show();
            }).catch(e=>{
                loading.close();
                console.log('e:'+e)
                this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
            })
        },
        /**菜品检索 */
        foodFilter(value, data){
            if (!value) return true;
            value=value.toLocaleUpperCase();
            return data.Food_Code?.toLocaleUpperCase().includes(value) || data.Food_Name?.toLocaleUpperCase().includes(value) || data.Food_PinYin?.toLocaleUpperCase().includes(value);
        },
        /**选中的菜品 */
        changeFood(data){
            const foods=data.filter(it=>it.Food_Name);
            if(foods.length==0){
                this.$message.warning("请勾选需要打印的菜品！");
                return;
            }
            const loading = this.$loading({
                text: "获取物料信息中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetFoodPrintMaterials", {
                Eat_XFBMIDs:foods.map(it=>it.id)
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{
                    const errList=foods.filter(it=>!d.ResponseBody?.some(item=>item.Eat_XFBMID==it.id)).map(it=>it.name);
                    if(errList.length>0){
                        this.$message.error(`菜品(${errList.join(',')})未设置扣除物料，无法加入打印列表！`);
                    }
                    console.log(d)
                    d.ResponseBody?.forEach(it=>{
                        it.Food_CheckPrice=it.Eat_SalePrice;
                        this.foodList.push(it);
                    })
                    this.$refs.treeFood?.hide();
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("获取物料信息失败"+e.message, "提示", {confirmButtonText: "确定"});
            });

        },
        //添加菜品
        addFood(){
            if((this.posFoodData||[]).length==0){
                this.loadFoods();
            }else{
                this.$refs.treeFood?.show();
            }
        },
        /**点击批量操作 */
        clickBatch(title,key){
            if(this.foodList.length==0){
                this.$message.warning("请添加需要打印的菜品！");
                return ;
            }
            /**批量操作字段 */
            this.batNumKey=key;
            /**标题 */
            this.batNumTitle="批量修改"+title;
            if(key=="DiscountDesc"){
                this.$prompt('',this.batNumTitle, {

                }).then(({ value }) => {
                    this.batConfirm(value);
                }).catch(() => {
                
                })
            }else{
                /**数字批量 */
                this.batNumShow=true;
            }
        },
        batConfirm(val){
            this.foodList.forEach(it=>{
                it[this.batNumKey]=val;
            })
            this.batNumShow=false;
        },
        //全部删除
        deleteClick(){
            this.foodList=[];
        },
        /**
         * 删除单个
         */
        delFood(row,index){
            this.foodList.splice(index,1);
        },
        /**折扣发生修改 */
        perChange(row){
            const num='零一二三四五六七八九';
            if(row.Print_Per>0 && row.Print_Per<100){
                if(row.Print_Per>=10){
                    let per=row.Print_Per%10;
                    row.DiscountDesc=num[parseInt(row.Print_Per/10)]+(per>0?num[per]:'')+"折";
                }else{
                    row.DiscountDesc=num[0]+num[row.Print_Per]+"折";
                }
                row.Food_CheckPrice=Number((row.Eat_SalePrice*(row.Print_Per/100)).toFixed(2));
            }else{
                row.DiscountDesc="";
                row.Food_CheckPrice=row.Eat_SalePrice;
            }
        },
        /**打印 */
        printClick(){
            if(!this.Printer_ID){
                this.$message.warning("请选择打印机！");
                return ;
            }
            if(!this.Print_ModelID){
                this.$message.warning("请选择打印标签模板！");
                return ;
            }
            if((this.foodList||[]).length==0){
                this.$message.warning("请添加需要打印的菜品！");
                return ;
            }
            try {
                this.foodList.forEach((it,index)=>{
                    if(!(it.Print_Num>=1)){
                        this.$message.warning("请输入打印份数！");
                        console.log(this.$el.querySelector(".printNum[data-id='"+index+"']"))
                        this.$el.querySelector(".printNum[data-id='"+index+"']")?.focus();
                        throw ""
                    }
                })
            } catch (error) {
                return ;
            }
            let userInfo = this.$auth.getUserInfo();
            let param={
                Printer_AutoID:this.Printer_ID,
                Printer_Name:this.printers?.find(it=>it.Printer_AutoID==this.Printer_ID)?.Printer_Name,
                Print_TemplateID:this.Print_ModelID,
                ProductionDate:new Date(this.produceDate).Format("yyyy-MM-dd"),
                FoodLabelItems:this.foodList.map(it=>{
                    return {
                        Food_ID:it.Eat_XFBMID,
                        Food_Code:it.Eat_XFCode,
                        Food_Name:it.Eat_XFName,
                        Food_Size:it.Eat_XFSize,
                        Print_Num:it.Print_Num,
                        Food_Price:it.Eat_SalePrice,
                        Food_CheckPrice:it.Food_CheckPrice,
                        DiscountDesc:it.DiscountDesc,
                        FoodIngredients:it.Batching,
                        FoodProducer:it.Manufacturer,
                        ShelfLife:it.Retention_Time,
                        StorageConditions:it.Storage_conditions,
                        ThirdpartyCode:it.Eat_XFThirdCode
                    }
                }),
                Operator_Name:userInfo.Login_Name
            };
            const loading = this.$loading({
                text: "获取菜品标签打印信息中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetFoodLabelPrintContent", param).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{//
                    this.$webBrowser.posPrint(d.ResponseBody);
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("获取菜品标签打印信息失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
        /**Excel导出 */
        exportExcel(){
            // if(!this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserPrintReports){
            //     this.$message.warning('您没有导出报表权限，请先分配权限！');
            //     return;
            // }
            this.$excelCommon.elTableToExcel({
                elTable:this.$refs.foodTable,
                titleName:"半成品标签统计表",
                list:this.foodList
            })
        },
    }
}
</script>

<style lang="scss">
@import './printLabel.scss'
</style>